var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditTitleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.563,
    height: 27.594,
    viewBox: "0 0 27.563 27.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-10.634 -3.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(10.736 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M26.909,27.394h.185l8.931-1.943a.879.879,0,0,0,.463-.231L51.618,10.088A5.831,5.831,0,0,0,53.33,5.924a6.015,6.015,0,0,0-1.712-4.211A5.83,5.83,0,0,0,47.454,0a5.692,5.692,0,0,0-4.165,1.758L28.2,16.89a.833.833,0,0,0-.278.416l-1.943,8.931a1.018,1.018,0,0,0,.278.879A.925.925,0,0,0,26.909,27.394ZM47.454,1.852A4.026,4.026,0,0,1,51.48,5.877q0,.023,0,.046a3.887,3.887,0,0,1-1.157,2.823L44.631,3.008A3.979,3.979,0,0,1,47.454,1.852Zm-4.118,2.5,5.692,5.692L35.839,23.183l-5.692-5.645ZM29.407,19.389l4.581,4.581-5.877,1.3Z",
    transform: "translate(-25.97 0)",
    fill: "#284866",
    stroke: "#284866",
    strokeWidth: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTitleIcon);
export default __webpack_public_path__ + "static/media/edit-title-icon.9e92be75a6b5ee7c0568754a7b4c95dc.svg";
export { ForwardRef as ReactComponent };